<template>
    <div class="gcmcn-card manual-receiver">
        <div class="mr-header mr-bold">
            {{ receiver.name }}
            <div>
                <el-button
                    class="gcmcn-primary-btn small"
                    type="primary"
                    icon="el-icon-edit"
                    @click="editManualReceiver"
                ></el-button>
                <el-popover
                    ref="remove-popover"
                    placement="bottom"
                    width="148"
                    trigger="click"
                    popper-class="dark-popper"
                    @hide="hideSubscribePopover"
                >
                    <div>
                        <div class="popover-title">ARE YOU SURE TO REMOVE THIS MANUAL RECEIVER ?</div>
                        <div class="actions">
                            <el-button type="text" class="decline" @click="hideSubscribePopover()">No</el-button>
                            <el-button type="text" class="accept" @click="removeManuelReceiver">Yes</el-button>
                        </div>
                    </div>
                    <el-button
                        slot="reference"
                        :loading="loading"
                        class="mr-remove-btn gcmcn-primary-btn small"
                        icon="el-icon-delete"
                        type="primary"
                    ></el-button>
                </el-popover>
            </div>
        </div>
        <div class="mr-body">
            <div>
                <img src="../../../../static/img/select-inputs-ird-box.svg">
                <div class="ird-inputs-container">
                    <div
                        v-for="input in 8"
                        :key="input"
                        class="ird-input"
                    ></div>
                </div>
            </div>
            <div v-if="receiver.public_ip">
                <div class="mr-title">PUBLIC IP</div>
                <div class="mr-bold">{{ receiver.public_ip }}</div>
            </div>
            <div v-if="receiver.destination">
                <div class="mr-title">DESTINATION</div>
                <div class="mr-bold">{{ receiver.destination }}</div>
            </div>
            <div v-if="getHardwareType ==='zixi'">
                <div class="mr-title">ZIXI ID</div>
                <div class="mr-bold">{{ receiver.remote_id }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    components: {
    },

    props: {
        receiver: {
            type: Object,
            required: true,
        },
    },

    data (){
        return {
            loading: false,
        };
    },

    computed: {
        getHardwareType() {
            return this.receiver.source_protocol_type;
        },
    },

    methods: {
        hideSubscribePopover() {
            if (this.$refs['remove-popover']) {
                this.$refs['remove-popover'].showPopper = false;
            }
        },
        removeManuelReceiver (){
            this.loading = true;
            this.$store.dispatch('patchItem', {
                item: {
                    uid: this.receiver.uid,
                    url: this.receiver.url,
                    archived: true,
                },
                model: 'manualReceivers',
            }).then(() => {
                this.$message({
                    message: `Manual receiver ${this.receiver.remote_id} removed`,
                    type: 'success'
                });
                this.$emit('manual-receiver-archived');
            }).catch((e) => {
                console.error(e);
                this.loading = false;
            });
        },
        editManualReceiver(){
            this.$emit('edit-receiver', this.receiver);
        }
    },
};
</script>

<style lang="scss">
.manual-receiver{
    width: 680px;
    color: #bbb;
    margin-bottom: 20px;

    .mr-header{
        display: flex;
        justify-content: space-between;

        .mr-remove-btn{
            padding: 2px 6px;
            background-color: #00A3FF;
            border-color: #00A3FF;
        }
    }
    .mr-bold{
        font-weight: bold;
        font-size: 18px;
    }

    .mr-body{
        display: flex;
        align-items: center;
        height: 120px;

        & > div:first-child{
            position: relative;
            margin-right: 20px;
            .ird-inputs-container{
                width: 80%;
                position: absolute;
                top: 38px;
                display: flex;
                justify-content: space-between;
                left: 50%;
                transform: translateX(-50%);


                .ird-input{
                    width: 15px;
                    height: 15px;
                    border: 1px solid #00A3FF;
                    border-radius: 50%;

                    &.selected{
                        background-color: #00a3ff;
                    }
                    &:last-child{
                        margin-right: 0;
                    }
                }
            }
        }
        & > div:not(:first-child){
            width: 150px;
            margin-right: 20px;

            .mr-title{
                font-family: roboto-light;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Settings/manual-receiver.vue